import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fw-normal" }
const _hoisted_2 = { class: "form mb-48" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-trash fw-bold me-8"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    size: "xl",
    "class-name": "modal-fullscreen-lg-down",
    onClosed: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('Eliminar')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('profesional')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('borrar profesional')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            variant: "link-secondary",
            class: "me-24",
            "aria-label": _ctx.$t('Cancelar'),
            "data-bs-dismiss": "modal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"]),
          _createVNode(_component_v_button, {
            "aria-label": _ctx.$t('Eliminar'),
            class: "btn-icon",
            variant: "secondary",
            onClick: _ctx.destroyProfessional
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Eliminar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClosed"]))
}